export default "__VITE_ASSET__JnBXndkb__"